const ActivitiesSkeleton = () => {
    return (
        <div className="accordion accordion-flush mb-3 placeholder-glow">
            <div className="d-flex align-items-start p-2" id={`placeholder-task`}>
                {/* Avatar placeholder */}
                <div className="flex-shrink-0">
                    <span className="placeholder rounded-circle bg-secondary me-3" style={{ width: "32px", height: "32px", display: "inline-block" }}></span>
                </div>

                {/* Task Content Placeholder */}
                <div className="flex-grow-1 ms-2">
                    {/* Title, timestamp, and badge */}
                    <div className="d-flex flex-wrap align-items-center mb-2">
                        <span className="placeholder col-4 bg-secondary me-2 mb-1" style={{ height: "16px" }}></span>
                        <span className="placeholder col-2 bg-secondary me-2 mb-1" style={{ height: "12px" }}></span>
                        <span className="placeholder badge bg-secondary-subtle text-secondary border border-secondary-subtle mb-1" style={{ width: "50px", height: "18px" }}></span>
                    </div>

                    {/* Status & Priority placeholders */}
                    <div className="d-flex gap-2 mb-2">
                        <span className="placeholder col-2 bg-secondary" style={{ height: "14px" }}></span>
                        <span className="placeholder col-2 bg-secondary" style={{ height: "14px" }}></span>
                    </div>

                    {/* Assigned user group */}
                    <div className="avatar-group mt-2">
                        <span className="placeholder rounded-circle bg-secondary" style={{ width: "24px", height: "24px", display: "inline-block" }}></span>
                        <span className="placeholder rounded-circle bg-secondary ms-1" style={{ width: "24px", height: "24px", display: "inline-block" }}></span>
                    </div>
                </div>
            </div>

            {/* Render time placeholder */}
            <small className="ms-5 text-muted placeholder col-2 bg-secondary" style={{ height: "12px" }}></small>
        </div>
    );
};

export default ActivitiesSkeleton;
